module.exports = __webpack_public_path__ + "static/media/2021_2A3A1070.97606056.jpg";